// src/components/Auth/AuthHeader.jsx
import React from "react";
import {Button} from "antd";
import {LogoMarkUpdated} from "../../vectorImages/LogoMarkUpdated"

const AuthHeader = ({
                        active = "signup",
                        onSignupClick,
                        onLoginClick,
                        signupText = "Sign up",
                        loginText = "Log in",
                        logoSrc = LogoMarkUpdated,
                    }) => {
    const isSignup = active === "signup";

    const base =
        "rounded-full min-w-24 h-9 w-full border-0 whitespace-nowrap transition-colors text-base";

    const activeTab = "bg-[#1b152b] text-white";
    const inactiveTab = "bg-[#c7a0f9] text-white";

    const signupClass = `${base} ${isSignup ? activeTab : inactiveTab}`;
    const loginClass = `${base} ${!isSignup ? activeTab : inactiveTab}`;

    return (
        <div className="flex flex-col items-center gap-4">
            <LogoMarkUpdated size={120} />

            <div className="grid grid-cols-2 gap-5 w-full max-w-[320px]">
                {/*<Button*/}
                {/*    className={signupClass}*/}
                {/*    aria-pressed={isSignup}*/}
                {/*    onClick={!isSignup ? onSignupClick : undefined}*/}
                {/*>*/}
                {/*    <span className="block truncate">*/}
                {/*    {signupText}*/}
                {/*    </span>*/}
                {/*</Button>*/}

                {/*<Button*/}
                {/*    className={loginClass}*/}
                {/*    aria-pressed={!isSignup}*/}
                {/*    onClick={isSignup ? onLoginClick : undefined}*/}
                {/*>*/}
                {/*    <span className="block truncate">*/}
                {/*    {loginText}*/}
                {/*    </span>*/}
                {/*</Button>*/}
            </div>
        </div>
    );
};

export default AuthHeader

